import type { AxiosError } from 'axios';
import type { ProgramInviteType, UserList } from 'models';
import { AxiosErrorHandler, type FormInstance } from 'ui';

import type {
  EmailSelectedUser,
  EmailSelectedUserWithRole,
  RegisteredSelectedUser,
  RegisteredSelectedUserWithRole,
} from '../../../../types';
import EventInvitees, { type InviteesType } from '../../../EventInvitees';

import { type CommonFormValues, mapInviteTypeToRole } from './hooks';

type P = {
  allowedInvites?: InviteesType[];
  data?: UserList[];
  error?: AxiosError | null;
  fetchNextPage?: () => unknown;
  form: FormInstance<CommonFormValues>;
  hasNextPage?: boolean;
  inviteType: ProgramInviteType;
  isFetching: boolean;
  isLoading: boolean;
  isRefetching: boolean;
  onBack?: () => void;
  onInvite: (
    inviteType: ProgramInviteType,
    invitees: RegisteredSelectedUser[],
    emailInvitees?: EmailSelectedUser[],
  ) => void;
  onSearch: (value: string) => void;
};

const InviteesPicker = ({
  allowedInvites,
  data,
  error,
  fetchNextPage,
  form,
  hasNextPage,
  inviteType,
  isFetching,
  isLoading,
  isRefetching,
  onBack,
  onInvite,
  onSearch,
}: P) => {
  const requiredRole = mapInviteTypeToRole(inviteType);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const chosenRegistered: RegisteredSelectedUserWithRole[] = form.getFieldValue('invitees') ?? [];
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const chosenEmails: EmailSelectedUserWithRole[] = form.getFieldValue('emailInvitees') ?? [];

  return (
    <AxiosErrorHandler actions={false} error={error}>
      <EventInvitees
        allowedInvitees={allowedInvites}
        allUsers={data}
        chosenEmails={chosenEmails.filter((choosen) => choosen.eventRole === requiredRole)}
        chosenRegistered={chosenRegistered.filter((choosen) => choosen.eventRole === requiredRole)}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        inviteType={inviteType}
        isFetching={isFetching}
        isLoading={isLoading}
        isRefetching={isRefetching}
        onBack={onBack}
        onInvite={onInvite}
        onSearch={onSearch}
      />
    </AxiosErrorHandler>
  );
};

export default InviteesPicker;
